<script lang="ts">
    export let amountSupporter;
    export let amountDonatedMoney;
    export let resultDate;
    const month_english_list = ['Jan','Feb','Mar','Apr','May','June','July','Aug','Sept','Oct','Nov','Dec']
</script>

<section id="project-result-section">
    <div class="container">
        <h2 class="container__title">
            Progress Report
        </h2>
        <div class="result-container">
            <div class="result-container__label">
                Number Of Supporter
            </div>
            <div class="result-container__body">
                <span class="result-container__body--number">{amountSupporter}</span> people
            </div>
        </div>
        <div class="result-container">
            <div class="result-container__label">
                Amount Of Money
            </div>
            <div class="result-container__body">
                <span class="result-container__body--number">$ {Math.round(amountDonatedMoney / 147).toLocaleString()}</span>
            </div>
        </div>
        <div class="result-container__bottom-message">
            ※School and team are calculated by one person.<br>
            {`※As Of ${month_english_list[resultDate.getMonth()]}, ${resultDate.getDate()}, ${resultDate.getFullYear()}`}
        </div>
        <div class="amount-of-goal">
            <div class="amount-of-goal__title">Target Amount</div>
            <div class="amount-of-goal__body">
                <span class="amount-of-goal__body--number">$ {Math.round(15000000 / 147).toLocaleString()}</span>
            </div>
        </div>
        <div class="reason-of-goal">
            <div class="reason-of-goal__title">
                Reason Of Target Amount
            </div>
            <ul class="reason-of-goal__list">
                <li>
                    Transfer to a specialized rehabilitation facility within the year after completion of current regenerative medicine.<br>
                    ※While receiving advice from the hospital, the patient and his/her family are considering a transfer destination from various directions.
                </li>
                <li>
                    When receiving another regenerative medicine in the future, 
                    it will not be covered by insurance and will incur high treatment costs.<br>
                </li>
                <li>
                    When it comes to cutting-edge medical care overseas, travel expenses, etc., are required in addition to treatment costs.
                </li>
                <li>
                    In addition to the cost of treatment, there is a corona whirlpool in a distant place, and it is prohibited to accompany 
                    family members at the hospital, so in addition to transportation expenses, accommodation expenses, etc. are also required.
                </li>
                <li>
                    The need for support in reintegrating into society after completing the rehabilitation period.
                </li>
                <li>
                    Since the insurance coverage is only for two months after the accident, four months have passed since the accident, and you are paying your own expenses.
                </li>
            </ul>
            <div class=reason-of-goal__bottom-message>We decided the amount based on the above information.</div> 
        </div>
    </div>
</section>

<style>
    #project-result-section {
        background-color: #ffffff;
        padding:            32px 0;
    }

    #project-result-section .container{
        margin:     0 auto;
        padding:    0 20px;
        text-align: center;
    }

    #project-result-section .container__title{
        font-size:     30px;
        font-weight:   bold;
        color:         #333333;
        margin-bottom: 56px;
    }
    
    #project-result-section .container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            25%;
        background-color: #1a2382;
        transform:        translate(131%, 16px);
    }

    #project-result-section .result-container {
        display:          inline-block;
        width:            313px;
        margin-bottom:    16px;
        padding:          20px;
        background-color: #484f9a;
        color:            white;
        border-radius:    8px;
    }

    #project-result-section .result-container:first-of-type {
        margin-right: 16px;
    }

    #project-result-section .result-container__label {
        margin-bottom: 16px;
        font-size:     24px;
    }

    #project-result-section .result-container__label:after {
        content:          "";
        display:          block;
        width:            150px;
        height:           2px;
        background-color: white;
        border-radius:    1em;
        transform:        translate(80px, 8px);
    }

    #project-result-section .result-container__body {
        font-size:   24px;
        font-weight: bold;
    }

    #project-result-section .result-container__body--number {
        font-size: 40px;
    }

    #project-result-section .result-container__bottom-message {
        margin:     0 auto 64px;
        text-align: left;
    }

    #project-result-section .amount-of-goal {
        padding:          24px 0;
        margin:           0 auto 80px;
        border-radius:    1em;
        border:           4px dotted #de6c6c;
    }

    #project-result-section .amount-of-goal:after {
        content:          "";
        display:          block;
        width:            300px;
        height:           6px;
        margin:           0 auto;    
        background-color: #f69a9a;
        border-radius:    1em;
    }

    #project-result-section .amount-of-goal__title {
        display:      inline-block;
        margin-right: 16px;
        font-size:    32px;
        font-weight:  bold;
    }

    #project-result-section .amount-of-goal__body {
        display:       inline-block;
        margin-bottom: 8px;
        font-size:     26px;
    }

    #project-result-section .amount-of-goal__body--number{
        font-size:     48px;
        font-weight:   bold;
    }

    #project-result-section .reason-of-goal {
        text-align: left;
    }

    #project-result-section .reason-of-goal__title {
        margin-bottom: 16px;
        font-size:     24px;
        font-weight:   bold;
    }

    #project-result-section .reason-of-goal__list {
        margin:           0 0 16px;
        padding:          20px 20px 20px 32px;
        background-color: #e1e1e1;
        border-radius:    8px;
    }

    #project-result-section .reason-of-goal__list li:not(:last-child) {
        margin-bottom: 16px;
    }
</style>